// extracted by mini-css-extract-plugin
module.exports = {"School":"school_School__3qqN_","grow":"school_grow__Kg6V5"};